var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLawyer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 49,
    viewBox: "0 0 54 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 49,
    fill: "url(#pattern0_396_28)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_396_28",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_396_28",
    transform: "matrix(0.0100823 0 0 0.0111111 0.0462963 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_396_28",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADsUlEQVR4nO3dS6gXVRwH8F9mJiVEDxJMKCOyoFUErkxaRBA9CdoUbUJp0QNaZEQbCbQoKKFF0Sba1C6CNllGL7AHhCK9jIrC7CG0MCN7+YnRoUX0v/3nzv8/58yZ+awv5/zOl7lzZ86cc27EaDQajUaj0Wg0Go2awQW4Hc/gDXyDn/AXfsHXeBNbcGnD5ocNp+JOfKi5nbgk9RiyhhOwEQe1cwS3ph5PlnAmXjE71a3lhtTjygpW43OzV/1m3IPrsDKGDKfjU/P3G57DOTHQe/LLunUA62JIcJs0qsfD82IIcDL2S+etGAJskt5VUTq8mzplvBYlw0p5+BNnRalwo3zcEqXCY/LxeJQKr8vHjigV9srHF1EqfCsfB6NU+FU+jkSpcEg+DkWpdDNbN63PolRmO8Hf1s4oFR6Ujy1RKqyTj8ujZPgkdcL4EkuiZHgidcrYHiXD+nrmLLWqhvVRKrwkHy9GqfCRfOyNUuED+Xg/SuX4gsVcPBWlwjXycXUUvnDmndQJY1dVS5QM52NPwpB3Y00MBbYnCLnsF5X/gmsTBF3ufXkSLMMPHYb8PU6KIcL9HQZ9VwwVTsFXHYRcfX1fGkOGK+vtEPNStX1F6nEO4cvLA6nHl9uLzAtzCPn54l9MmsKJM362fnqwTxnTmFXKU3U2ZMagu2EMuhuaebXe2nxRtY+8YT/L602f7+HwAn0crreD3F1tdIpSmM4+bGi5Y3fPImf+VkcJ/L+3cUaL9pe3nKbd3esrGzdNsVB9X5uQ636q28Uw500cX+9xdIoBbphBX9U9ua1d0Uem+7w1k72B+Hlwa6uxBHdMObiNC8xrP1Jvqs9NtZXk4arG7tONY+GcjXurxeANil47oa1qILnb1mW459Z/iKpn398XUeyKCe3meCX/24F5z8hdhodm8dV7gX56YR4BX4hHZ31URIxBHxvsUtxcH4l2tMtC9cQsQr4eH6cqVE+0Cfi0+lCopIXqicWGvKZ+HU5eqJ5Y7Jmh3+VSqJ5oGvKKVCcUxMCCfjK3QvVEk5Avxh+5FarAoJ/NsVA90WSNXNIjIGIgQSc/3Svmc6pNdUDsfVi1QPursLn+2cXaP23QWyUWk2vb1qLZzR0tMd46bSc7JBaTa1tWh72YK3vilTzhym5qf32RTjfxP6fDtBuJIcCPEoshqP9JwRj0aDQq7ODvtU0XOXb4D3yqBZibou/0RPSdnoi+0xPRd/I6wbfdXEfOtJvr6Mp0cx05026uY97+mev4G8D58oPAsmZXAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLawyer);
export default __webpack_public_path__ + "static/media/Lawyer.50b69f0dcca95da283dcead2d17a9dab.svg";
export { ForwardRef as ReactComponent };